import axios from 'axios';
import Cookies from 'universal-cookie';
import { env } from '../../../config';
const checkoutSourceClient = 'webcheckout';
const tokenResponseType = 'token';
const spliceStartPosition = -2;
const spliceDeleteCount = 1;
const grantType = 'refresh_token';

export class RedirectionService
{
    private tenantId: string;

    private xsrfPromise: Promise<string> | null = null;

    constructor(tenantId: string)
    {
        this.tenantId = tenantId;
    }

    public getUrl = (url: string): string =>
    {
        const initialUrlArray = url.split('.');

        initialUrlArray[1] = this.tenantId;

        return initialUrlArray.join('.');
    };

    /**
     * Redirects to authorize page.
     */
    public login = (pathname: string): void =>
    {
        const responseType = `response_type=${tokenResponseType}`;
        const sourceClient = `source_client=${checkoutSourceClient}`;
        const source = 'source=titancheckout';
        const pathName = `/checkout/callback${pathname}`;
        const redirectUri = `redirect_uri=${encodeURIComponent(window.location.origin + pathName)}`;

        window.location.href = `${this.getTransformedURL(
            this.tenantId,
            env('REACT_APP_IDENTITY_API_BASE_URL')
        )}identity-service/auth/authorize?${responseType}&${sourceClient}&${redirectUri}&${source}`;
    };

    public getToken = async (): Promise<string> =>
    {
        // Ensure XSRF token is set before requesting the ID token
        const xsrfToken = await this.getXsrfToken(this.tenantId);

        const URL = `${this.getTransformedURL(this.tenantId, env('REACT_APP_IDENTITY_API_BASE_URL'))}identity-service/auth/token`;
        const payloadBody = {
            grantType: grantType,
            sourceClient: checkoutSourceClient
        };
        const reqConfig = {
            withCredentials: true,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': xsrfToken
            }
        };
        const { data: { id_token: idToken }} = await axios.post(URL, payloadBody, reqConfig);

        return idToken;
    };

    /**
     * Returns URL for specific tenant.
     */
    public getTransformedURL = (tenantId: string, environmentURL = ''): string =>
    {
        const urlArray = environmentURL.split('.');

        urlArray.splice(spliceStartPosition, spliceDeleteCount, tenantId);

        return urlArray.join('.');
    };

    /**
     * Returns XSRF token.
     */
    public async getXsrfToken(tenantId: string): Promise<string> {
        const cookies = new Cookies();
        
        const existingToken = cookies.get('XSRF-TOKEN');

        if (existingToken) {
            return existingToken;
        }

        if (!this.xsrfPromise) {
            const URL = `${this.getTransformedURL(this.tenantId, env('REACT_APP_IDENTITY_API_BASE_URL'))}identity-service/xsrf-token`;

            this.xsrfPromise = (async () => {
                await axios.get(URL, {
                    withCredentials: true
                });

                return cookies.get('XSRF-TOKEN');
            })().finally(() => {
                this.xsrfPromise = null;
            });
        }

        return this.xsrfPromise;
    }
}
